import { navigate, RouteComponentProps } from '@reach/router';
import { Spinner } from 'components/spinner/Spinner';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCultureCode } from 'reducers/dashboardInfo';
import { AssessmentSubmission } from '../virtualAssessments/AssessmentSubmission';
import { selectAccessibilityData } from 'reducers/accessibility';
import { GenericActivityFooter } from 'components/activityComponents/genericActivityFooter/GenericActivityFooter';
import { completeStage } from '../viewApplication/ViewApplicationStages';
import i18n from 'i18n/i18n';
import { useTranslation } from 'react-i18next';

import Icon_Warning from '../../../assets/apply.clevry/Icon_Warning.png';

interface IFramedProngProps extends RouteComponentProps {
  redirectUrl: string;
  iframeUrl: string;
  redirectUrlProps?: any;
  customClassName?: string;
  isLastAssessmentInStage?: boolean;
  jobApplicationId?: number;
  projectId?: number;
}

const IFramedProng: React.FC<IFramedProngProps> = ({
  redirectUrl,
  iframeUrl,
  redirectUrlProps,
  customClassName,
  isLastAssessmentInStage,
  jobApplicationId,
  projectId,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const cultureCode = useSelector(selectCultureCode);
  const addLanguageToUrl = iframeUrl + `&language=${cultureCode}`;
  const [error, setError] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const autoSubmitLastPage = isLastAssessmentInStage === true ? false : true;
  console.log('PRONG autoSubmitLastPage 1: ', autoSubmitLastPage);
  const [assessmentName, setAssessmentName] = useState<string>('');
  const [showSubmitPage, setShowSubmitPage] = useState<boolean>(false);

  const { t } = useTranslation(['IFrame'], { i18n });

  console.log('PRONG autoSubmitLastPage: ', autoSubmitLastPage);

  React.useEffect(() => {
    window.addEventListener('message', function (e) {
      console.log('PRONG e: ', e);

      if (e.data.closeStagesProng) {
        console.log('PRONG autoSubmitLastPage: ', autoSubmitLastPage);
        if (autoSubmitLastPage) {
          setShowSubmitPage(false);
          if (
            redirectUrlProps &&
            typeof redirectUrlProps === 'object' &&
            Object.keys(redirectUrlProps).length > 0
          ) {
            navigate(redirectUrl, { state: { ...redirectUrlProps } });
          } else {
            navigate(redirectUrl);
          }
        } else {
          setShowSubmitPage(true);
        }
      }
    });
  }, [redirectUrl, redirectUrlProps]);

  const handleToggle = () => {
    setIsConfirmed(!isConfirmed);
  };

  /// Accessbility styles

  const accessibilityData = useSelector(selectAccessibilityData);

  const style = accessibilityData.isSet
    ? ({
        '--backgroundColor': `${accessibilityData.backgroundColor}`,
        '--fontColor': `${accessibilityData.textColor}`,
        '--titleColor': `${accessibilityData.titleColor}`,
        '--borderColor': `${accessibilityData.borderColor}`,
      } as React.CSSProperties)
    : ({
        '--backgroundColor': '#fff',
        '--fontColor': '#000',
        '--titleColor': '#036C8F',
        '--borderColor': '#000',
      } as React.CSSProperties);

  const progressBarStyle = accessibilityData.isSet
    ? ({
        '--progressBarCompleteColor': accessibilityData.textColor,
        '--progressBarNoGradientColor': accessibilityData.textColor,
        '--progressBarIncompleteColor': accessibilityData.backgroundColor,
        '--progressBarBorderColor': accessibilityData.textColor,
      } as React.CSSProperties)
    : ({
        '--progressBarCompleteColor': '#731447',
        '--progressBarIncompleteColor': '#545454',
        '--progressBarBorderColor': '#D5D5D5',
      } as React.CSSProperties);

  const footerStyle = accessibilityData.isSet
    ? ({
        '--footerBackgroundColor': accessibilityData.backgroundColor,
        '--footerFontColor': accessibilityData.textColor,
        '--footerBorderColor': accessibilityData.textColor,
        '--primaryButtonFontColor': accessibilityData.textColor,
        '--tertiaryButtonFontColor': accessibilityData.textColor,
      } as React.CSSProperties)
    : ({
        '--footerBackgroundColor': '#f5f5f5',
        '--footerBorderColor': '#f5f5f5',
        '--primaryButtonFontColor': '#fff',
        '--tertiaryButtonFontColor': '#000',
        '--primaryButtonBackgroundColor': '#731447',
        '--tertiaryButtonBackgroundColor': '#d5d5d5',
      } as React.CSSProperties);
  ///

  const handleStep = () => {
    if (!autoSubmitLastPage && isConfirmed) {
      (async () => {
        if (jobApplicationId && projectId) {
          return (async () => {
            const result = await completeStage(jobApplicationId, projectId);
            if (result.response) {
              setError(false);

              if (
                redirectUrlProps &&
                typeof redirectUrlProps === 'object' &&
                Object.keys(redirectUrlProps).length > 0
              ) {
                navigate(redirectUrl, { state: { ...redirectUrlProps } });
              } else {
                navigate(redirectUrl);
              }
            } else {
              setError(true);
            }
          })();
        }
      })();
    }
  };
  if (!error) {
    return (
      <>
        {isLoading && (
          <div className="FullScreenCover CenterContent">
            <Spinner />
          </div>
        )}
        <div
          className={`${customClassName ? customClassName : ''}`}
          style={{ maxHeight: '100vh', width: '100vw' }}
        >
          {!showSubmitPage ? (
            <iframe
              src={addLanguageToUrl}
              title="iframed-content"
              style={{ height: '100vh', width: '100%' }}
              onLoad={() => setIsLoading(false)}
            />
          ) : showSubmitPage && !autoSubmitLastPage ? (
            <div className="IFramedProngSubmitPage">
              <AssessmentSubmission
                isConfirmed={isConfirmed}
                handleToggle={handleToggle}
                assessmentName={assessmentName}
                style={footerStyle}
                submissionPageText={null}
              />
              <GenericActivityFooter
                step={1}
                permission={true}
                buttonTextMap={{
                  1: t(
                    'SSCandidate_Business_Case_Activity_Generic_Activity_Footer_Next'
                  ),
                }}
                incrementStep={handleStep}
                disabled={!autoSubmitLastPage && !isConfirmed}
              />
            </div>
          ) : null}
        </div>
      </>
    );
  } else {
    return (
      <div className="ErrorPage">
        <div className="ErrorCell">
          <div className="Img">
            <img src={Icon_Warning} alt={t('SSCandidate_IFrame_Alt_Error')} />
          </div>
          <div className="Txt">
            <h1>{t('SSCandidate_IFrame_Something_Went_Wrong')}</h1>
            <p>{t('SSCandidate_IFrame_Please_Try_Again')}</p>
          </div>
        </div>
      </div>
    );
  }
};

export default IFramedProng;
